export const TxLocal = {
  // //根据地址获取经纬度
  getLal: async (address: string): Promise<any> => {
    return new Promise((result) => {
      const qq = (window as any).qq as any
      const geocoder = new qq.maps.Geocoder()
      geocoder.getLocation(address)
      geocoder.setComplete(function (res: any) {
        console.log(res)
        const data = {
          success: true,
          address: res.detail.address,
          location: res.detail.location,
          locationStr: res.detail.location.lat + ',' + res.detail.location.lng,
          lat: res.detail.location.lat,
          lng: res.detail.location.lng,
        }
        result(data)
      })
      geocoder.setError(function (err: any) {
        result({
          success: false,
          address: address,
          location: [],
          locationStr: '',
          err: err,
        })
      })
    })
  },
  // getLal2: async (address) =>{
  //   const res = await axios.request({
  //     url:'https://apis.map.qq.com/ws/geocoder/v1',
  //     method: 'GET',
  //     data: {
  //       key: 'HTBBZ-VL7C3-LZU3G-Y5P4Z-BKWHQ-NGFSN',
  //       address,
  //       output: 'jsonp',
  //     }
  //   })
  //   console.log(res)
  //   return res
  // }
}
